import {api} from '../components/Base/App';

export default {
    create(externalCalendarCreateCommand) {
        return api({
            method: 'put',
            url: '/rest/extcalendars/',
            data: externalCalendarCreateCommand
        });
    },

    delete(calendarId) {
        return api({
            method: 'delete',
            url: `/rest/extcalendars/${calendarId}`
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/ExternalCalendars.js